<template>
  <div class="rule">
    <h2>{{ $t("laundering") }}</h2>
    <p>{{ $t("message-1") }}</p>
    <p>{{ $t("message-2") }}</p>
    <p>{{ $t("message-3") }}</p>
  </div>
</template>
<script>
export default {
  name: 'Help',
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      window.document.title = vm.$t('laundering')
    })
  },
}
</script>
<style lang="less" scoped>
.rule {
  font-family: "SF UI Text Semibold", sans-serif;
  padding: 0 0.4rem 0.54rem;
  font-size: 0.28rem;
  color: #636b82;

  h2 {
    font-size: 0.28rem;
    color: #1d212c;
    margin: 0.38rem 0 0.2rem;
  }

  p {
    margin: 0.16rem 0 0.2rem;
  }
}
</style>
